export default function Features() {
  return (
    <section className="min-h-screen bg-gradient-to-b from-[#3d2817] to-[#2a1810] py-32 px-20 flex items-center relative overflow-hidden">
      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-64 h-64 border border-white rotate-45"></div>
        <div className="absolute bottom-32 right-32 w-96 h-96 border border-white rotate-12"></div>
      </div>

      <div className="relative w-full flex items-center gap-20">
        {/* Left - Product Screenshot */}
        <div className="w-[35%]">
          <div className="rounded-xl overflow-hidden shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/3ecd6a27d673cc02e9f2780caf8d9e29.jpg" 
              alt="iOS VPN Application Interface" 
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Right - Content */}
        <div className="flex-1">
          <div className="inline-block bg-[#E8D5F2] px-4 py-2 rounded-md mb-8">
            <span className="text-sm text-[#2A1810] font-medium">/ Security First</span>
          </div>
          
          <div className="text-[120px] font-bold text-white/85 leading-none mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            01
          </div>
          
          <h4 className="text-[24px] font-light text-[#F0F0F0] leading-tight mb-10">
            Advanced Encryption<br />
            Technology Standards
          </h4>
          
          <p className="text-base text-[#D4C4B0] leading-[1.75] max-w-[520px]">
            Our <strong>VPN application</strong> implements military-grade AES-256 encryption to protect your data transmission. With support for multiple security protocols including OpenVPN, IKEv2, and WireGuard, we ensure your online activities remain private and secure. Our <strong>iOS security applications</strong> are built with privacy-first architecture, featuring zero-log policies and automatic kill switches to maintain your anonymity at all times.
          </p>
        </div>
      </div>
    </section>
  );
}